<template>
  <div class="alter-teacher">
    <Header title="选择教师课表" :type="type" :isShowArrow="false"></Header>
    <NOdata v-if="this.kbdatas.length == 0" title="未查询到上课班级信息"></NOdata>
    <template v-else>
      <div class="alter-item" v-for="(item,index) in kbdatas" :key="index">
        <div @click="select(item)">
          <h4>{{item.curname}}({{item.curnumber}})</h4>
          <p>学年学期：{{item.curxnxq}}</p>
          <p>通知单编号：{{item.curindex}}</p>
          <p>课堂名称：{{item.ktmc}}</p>
          <p>课程属性：{{item.kcsx}}</p>
        </div>
      </div>
      <div style="height:84px"></div>
    </template>
    <div class="alter-buttons">
      <button class="clear" @click="clear()">取消</button>
    </div>
  </div>
</template>
<script>
import { Api } from '../../utils/axios'
export default {
  props: {
    isRadio:{
      type:Boolean,
      default:false
    },
    list:{
      type:Array,
      default:() => []
    },
    ddParmMsg:{
      type:Array,
      default:{}
    }
  },
  data(){
    return{
      teacherKbList:[],
      teaInfo:'',
      route:'teacher',
      type:'1',
      ddKbid:'',
      kbTime:'',
      kkzcmx:''
    }
  },
  created(){
    this.teaTap()
  },
  methods:{
    select(item){
      this.$emit('closePop_ddkb',item.curindex,item.curname)
    },
    clear(){
      this.$emit('closePop_ddkb')
    },
    async teaTap(){
      const res = await Api.getTeachKtMsg()
      this.teacherKbList = res.data
      console.log(this.teacherKbList);
    }
  },
  computed:{
    kbdatas:function(){
      var author = this.teaInfo;
      if(author){
        return this.teacherKbList.filter(item=>item.classname.indexOf(author) > -1);
      }
      return this.teacherKbList
    }
  },
}
</script>
<style lang="less" >
.alter-teacher{
  padding: 5px 20px;
  margin: 70px 0 20px;
  .alter-find{
    border-radius:3px;
    background-color: @attendance-background-color-6;
    padding: 11px 13px;display: flex;
    i{
      background: url(../../assets/images/search.png)no-repeat center;
      background-size: 22px 22px;width: 22px;height: 22px;
    }
    input{
      color: @attendance-color-2;
      padding: 0 11px;flex: 1;
      &::placeholder{
        color: @attendance-color-2;
      }
    }
  }
  .alter-item{
    padding: 0 20px;
    background-color: @attendance-background-color-10;
    border-radius:5px;height: 122px;margin: 21px 0 13px;
    display: flex;justify-content: space-between;align-items: center;
    h4{
      color: @attendance-color-1;
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 8px;
    }
    p{
      color: @attendance-color-2;font-size: 12px;line-height: 17px;
    }
    /deep/.el-checkbox__inner{
      width: 18px;height: 18px;
      border-radius: 50%;
      border: 2px solid @attendance-border-color-4;
      &::after{
        left: 5px;top: 2px;border-width: 2px;
      }
    }
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner{
      background: @attendance-background-color-1;
      border-color:@attendance-background-color-1;
    }
  }
  .alter-buttons{
    z-index: 9;
    background-color: @attendance-color-3;
    position: fixed;bottom: 0;padding: 20px 0;
    width: calc(~"100% - 40px");box-sizing: border-box;
    display: flex;justify-content: space-between;align-items: center;
    button{
      width: calc(~"100% - 10px");padding: 11px 0;border-radius: 3px;
    }
    button.clear{
      background-color: @attendance-background-color-7;
      color: @attendance-background-color-1;
    }
    button.confirm{
      background-color: @attendance-background-color-1;
      color: @attendance-color-3;
    }
  }
}
</style>






















// WEBPACK FOOTER //
// src/components/common/alterTeacherCuareMsg.vue